var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { buildProductSearchFilters } from '../state/productSearch/filters';
import { additionalResultColumnNames, facetColumnNames } from '../state/productSearch/states'; // mirrors the API's ApprovedUseAttributesResponse/AttributeFieldDto (GET /approved-use-attributes)
export var fallbackURL = 'http://localhost:3003';
if (!process.env.REACT_APP_NEW_PRODUCT_SEARCH_API_URL) {
    console.log("No env variable found for REACT_APP_NEW_PRODUCT_SEARCH_API_URL. Using fallback ".concat(fallbackURL));
}
var productSearchApiBaseUrl = process.env.REACT_APP_NEW_PRODUCT_SEARCH_API_URL || fallbackURL; // POST /api/ProductSearch, mirroring ui-search's SearchApiClient.search.
// Currently both getProductSearchFacets and getProductSearchResults use the same endpoint and we have this shared function.
// May be extended in the future to handle different types of product search requests separately depending on API changes.
export function searchProducts(request) {
    return __awaiter(this, void 0, void 0, function () { var response; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch("".concat(productSearchApiBaseUrl, "/api/ProductSearch"), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(request) })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("ProductSearch API request failed with status ".concat(response.status));
                }
                return [2 /*return*/, response.json()];
        }
    }); });
} // Load each facet without applying that facet's own selection. This keeps the
// complete option list visible while counts reflect the other active filters, including for
// Approved Use - e.g. picking a Category still greys out Approved Uses with no matching products.
export function getProductSearchFacets(state) {
    return __awaiter(this, void 0, void 0, function () {
        var facetEntries;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(Object.entries(facetColumnNames).map(function (_ref) { return __awaiter(_this, void 0, void 0, function () {
                        var _response$facets$colu, facetId, columnName, facetState, filters, response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    facetId = _ref[0], columnName = _ref[1];
                                    facetState = facetId === 'approvedUse' && state.facets.category.autoSelected ? __assign(__assign({}, state), { facets: __assign(__assign({}, state.facets), { category: __assign(__assign({}, state.facets.category), { selectedValues: [] }) }) }) : state;
                                    filters = buildProductSearchFilters(facetState, facetId, facetId !== 'approvedUse');
                                    return [4 /*yield*/, searchProducts({ filters: filters.length > 0 ? filters : null, facetColumns: [columnName], facetsOnly: true })];
                                case 1:
                                    response = _a.sent();
                                    return [2 /*return*/, [columnName, (_response$facets$colu = response.facets[columnName]) !== null && _response$facets$colu !== void 0 ? _response$facets$colu : {}]];
                            }
                        });
                    }); }))];
                case 1:
                    facetEntries = _a.sent();
                    return [2 /*return*/, Object.fromEntries(facetEntries)];
            }
        });
    });
} // real (non-facetsOnly) search limited to the base facet columns; approved-use attribute
// columns and paging are not requested yet since that work is handled later
export function getProductSearchResults(state) {
    return __awaiter(this, void 0, void 0, function () { var filters, response; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                filters = buildProductSearchFilters(state);
                return [4 /*yield*/, searchProducts({ filters: filters.length > 0 ? filters : null, selectColumns: __spreadArray(__spreadArray([], Object.values(facetColumnNames), true), additionalResultColumnNames, true), skip: state.resultOffset, take: state.resultPageSize, orderBy: state.resultSortColumn, orderByDescending: state.resultSortDirection === 1 })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, { results: response.results, totalCount: response.totalCount }];
        }
    }); });
} // GET /api/ProductSearch/approved-use-attributes - returns only the attribute fields that belong
// to the given Approved Use (backend groups by AttrPrefix), so the UI never has to fetch or
// filter through the full ~300 column set to find the relevant ones
export function getApprovedUseAttributeFields(approvedUseCode) {
    return __awaiter(this, void 0, void 0, function () { var response; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch("".concat(productSearchApiBaseUrl, "/api/ProductSearch/approved-use-attributes?approvedUseCode=").concat(encodeURIComponent(approvedUseCode)))];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("ProductSearch approved-use-attributes API request failed with status ".concat(response.status));
                }
                return [2 /*return*/, response.json()];
        }
    }); });
} // facet counts (within the current filter context) for a specific Approved Use's attribute
// columns only - keeps the request/response scoped to relevant data instead of every column
export function getApprovedUseAttributeFacets(state, columnNames) {
    return __awaiter(this, void 0, void 0, function () { var filters, response; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (columnNames.length === 0)
                    return [2 /*return*/, {}];
                filters = buildProductSearchFilters(state);
                return [4 /*yield*/, searchProducts({ filters: filters.length > 0 ? filters : null, facetColumns: columnNames, facetsOnly: true })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.facets];
        }
    }); });
}
